import {Box, Typography} from "@mui/material";
import {useEffect, useRef} from "react";

import videojs from "video.js";
import 'video.js/dist/video-js.css';
//import 'video.js/dist/videojs-live.css';
import {useSelectedClip} from "../../../contexts/selectedClip";
import {useTheme} from "../../../contexts/theme";

interface MatchVideoPlayerProps {
    setVideoHeight: (height: number) => void;
    setTitleHeight: (height: number) => void;
    title: string;
    url: string;
    muted: boolean;
    setMuted: (muted: boolean) => void;
}

const MatchVideoPlayer: React.FC<MatchVideoPlayerProps> = ({setMuted, muted, setVideoHeight, setTitleHeight, title, url}) => {

    const videoRef = useRef<HTMLVideoElement>(null);
    const playerRef = useRef<any>(null);
    const titleRef = useRef<any>(null)
    const {selectedClip, setSelectedClip} = useSelectedClip();
    const theme = useTheme();

    const onResize = (event: any) => {
        if (videoRef && videoRef.current) {
            setVideoHeight(videoRef.current.clientHeight);
        }
    }

    const changeToMP4 = () => {
        if(selectedClip){
            playerRef.current.src({ src: selectedClip.src, type: 'video/mp4' });
            playerRef.current.load();
        }
    }

    const changeToM3U8 = () =>{
        if (setSelectedClip){
            setSelectedClip(undefined);
            playerRef.current.src({ src: url, type: 'application/x-mpegURL' });
            playerRef.current.play();
        }
    }

    const onVideoLoaded = () => {
        playerRef.current.play();
    }

    const initPlayer = () => {
        if (videoRef && videoRef.current && !playerRef.current) {
            playerRef.current = videojs(videoRef.current, {
                controls: true,
                preload: 'auto',
                liveui: true,
                sources: [{
                    src: url,
                    type: 'application/x-mpegURL'
                }]
            });
            playerRef.current.on('ended', changeToM3U8);
            playerRef.current.on('canplay', onVideoLoaded);
            playerRef.current.on('loadedmetadata', () => {
                playerRef.current.play();
            });
            playerRef.current.on('volumechange', function() {
                if (playerRef.current.muted()) {
                    setMuted(true)
                } else {
                    setMuted(false)
                }
            });
        }
    }

    useEffect(() => {
        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("resize", onResize);
        };
    }, []);

    useEffect(() => {
        /*console.log("Cambiato Video Ref", videoRef.current);
        if (videoRef && videoRef.current && !playerRef.current) {
            console.log("No istance of video js")
            setVideoHeight(videoRef.current.clientHeight);
            initPlayer();
        }*/
        if (videoRef && videoRef.current){
            setVideoHeight(videoRef.current.clientHeight);
        }
    }, [videoRef]);

    useEffect(() => {
        if(playerRef.current && url){
            playerRef.current.play();
        }
    }, [playerRef])

    useEffect(() => {
        if(titleRef && titleRef.current){
            setTitleHeight(titleRef.current.clientHeight);
        }
    }, [titleRef.current])

    useEffect(() => {
        if(url && !playerRef.current){
            setVideoHeight(videoRef.current!.clientHeight);
            initPlayer();
        }else if(url && playerRef.current){
            playerRef.current.src({
                src: url,
                type: 'application/x-mpegURL',
            });
        }
        return(() => {
            if (playerRef.current) {
                playerRef.current.pause()
                playerRef.current.dispose();
                playerRef.current = null;
            }
        })
    }, [url]);

    useEffect(changeToMP4, [selectedClip])
    useEffect(() => {
        if (playerRef.current){
            playerRef.current.muted(muted);
        }
    }, [muted]);


    return (
        <Box sx={{height: '100%'}}>
            <Typography fontSize={theme.fontSizes.title} fontWeight={theme.fontWeights.title} sx={{color: theme.palette.white, paddingBottom: theme.spacing.sm}}>{title}</Typography>
            <Box sx={{position: 'relative', paddingTop: '56.25%', width: '100%'}}>
                {url && <video ref={videoRef} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} className="video-js vjs-live vjs-liveui" controls preload="auto"></video>}
            </Box>
        </Box>
    );
};

export default MatchVideoPlayer;